import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import swal from "sweetalert";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import { getRankList } from "../Actions/RankManagementAPI";

let searchData = {
    Name: "",
    PageNumber: 1,
    PageSize: 25,
};
let userkey = JSON.parse(localStorage.getItem("currentUser"));

class AddRank extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Name: "",
            createdBy: userkey.name,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.SubmitData = this.SubmitData.bind(this);
    }

    handleInputChange(e) {
        this.state.Name = e.target.value;
        this.setState({});
    }

    SubmitData() {
        const { dispatch } = this.props;
        let rank = {
            rankName: this.state.Name,
            createdBy: this.state.createdBy,
        };
        if (this.state.Name !== "") {
            let url = `${API.PostRank}`;
            axios.post(url, rank)
                .then((response) => {
                    if (response.status === 500) {
                        swal("Error!", "Error when adding the data. Try again.", "warning");
                    } else {
                        if (response.data) {
                            toast.success("Added Successfully", {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            dispatch(getRankList(searchData))
                            this.hideSidePanel();
                        }
                        dispatch({
                            type: "PostRankSuccess",
                            data: response.data,
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status === 500) {
                        swal("Error!", "Already Exists.", "warning");
                        /*  toast.success(error.response.data.message, {
                             position: "top-right",
                             autoClose: 5000,
                             hideProgressBar: true,
                             closeOnClick: true,
                             pauseOnHover: true,
                             draggable: true,
                             progress: undefined,
                         }); */
                        dispatch({
                            type: "PostRankFailure",
                            data: "error",
                        });
                    }
                    else {
                        swal("Error!", "Something went wrong. Please try again.", "warning");
                        /*  toast.success(error.response.data.message, {
                             position: "top-right",
                             autoClose: 5000,
                             hideProgressBar: true,
                             closeOnClick: true,
                             pauseOnHover: true,
                             draggable: true,
                             progress: undefined,
                         }); */
                        dispatch({
                            type: "PostRankFailure",
                            data: "error",
                        });
                    }

                });
        } else {
            swal("Error!", "Please enter a Name", "warning");
        }
    }

    hideSidePanel = () => {
        this.props.history.push("/Home/Management/Rank");
    };
    BacktoPrevious() {
        this.props.history.goBack();
    }

    render() {
        return (
            <div className="full-height">
                <div className="pt-3">
                    <div className="row px-3 pb-3">
                        <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            onClick={() => this.BacktoPrevious()}
                        >
                            <div style={{ position: 'relative' }}>
                                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
                            </div>
                        </button>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="panel-box">
                                <div
                                    className="card MM-card-header mb-0"
                                    style={{ backgroundColor: "white", border: "0px" }}
                                >
                                    <div className="card-body">
                                        <h5
                                            className="card-title ml-1 pl-3 mt-2"
                                            style={{ color: "092a51" }}
                                        >
                                            Add Rank
                                        </h5>
                                    </div>
                                </div>
                                <div className="search-filter-box">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <label className="form-label">Name</label>
                                            <br></br>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="Name"
                                                placeholder="Name"
                                                value={this.state.Name}
                                                onChange={(e) => this.handleInputChange(e)}
                                            ></input>
                                        </div>
                                        <div className="col-lg-8">
                                            <label className="mt-4"></label>
                                            <br></br>
                                            <div className="search-btn-col" style={{ textAlign: "end" }}>
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit"
                                                    onClick={() => this.SubmitData()}
                                                >
                                                    {" "}
                                                    Submit{" "}
                                                </button>
                                                <button
                                                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                    type="button"
                                                    onClick={() => this.hideSidePanel()}
                                                >
                                                    {" "}
                                                    Cancel{" "}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        state,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AddRank)
);